<script setup lang="ts">
import { ref, onMounted } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue: string | number
    placeholder?: string
    error?: string
  }>(),
  {
    modelValue: '',
    placeholder: '#.##',
    error: ''
  }
)

const input = ref<any>(null)
const isShowInput = ref<boolean>(false)
const isShowLabel = ref<boolean>(true)

const emit = defineEmits(['update:modelValue', 'enter'])

const emitUpdate = (val: string) => {
  let returnValue = Number(val ?? 0)
  if (returnValue > 5) {
    returnValue = 5
  }

  emit('update:modelValue', returnValue)
}

const showInput = () => {
  isShowInput.value = true
  isShowLabel.value = false
  focusInput()
}

const focusInput = () => {
  setTimeout(() => {
    input.value.focus()
  }, 1)
}

const closeInput = () => {
  if (props.modelValue === '') return
  isShowInput.value = false
  isShowLabel.value = true
}

onMounted(() => {
  isShowInput.value = true
  isShowLabel.value = false
})
</script>
<template>
  <div class="flex">
    <label
      v-if="isShowLabel"
      @click="showInput"
      class="bg-white cursor-pointer drop-shadow-md font-bold flex text-sm justify-center items-center px-1 py-2 rounded-xl shadow-sm text-blue-600 text-center w-16"
      :class="[error ? 'border-red-500' : 'border-gray-300']">
      {{ modelValue }}
    </label>
    <input
      ref="input"
      @blur="closeInput"
      v-if="isShowInput"
      :placeholder="placeholder"
      :value="modelValue"
      style="appearance: none"
      type="number"
      maxlength="3"
      max="5"
      class="focus:outline-none focus:ring-1 focus:ring-blue-300 focus:border-transparent shadow-sm text-sm text-center rounded-xl py-2 px-1 w-16 text-blue-600 font-bold drop-shadow-md caret-blue-400 border"
      :class="[error ? 'border-red-500' : 'border-gray-300']"
      @input="($event: any) => emitUpdate($event.target.value)"
      @keyup.enter="emit('enter')" />
  </div>
</template>
<style>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  appearance: none;
}
</style>
